import { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Curriculum from './pages/Curriculum'
import Projects from './pages/Projects'
import ProjectDetail from './pages/ProjectDetail'
import Publications from './pages/Publications'
import CommandPalette from './components/CommandPalette'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}

export default function App() {
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setIsPaletteOpen(prev => !prev);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <CommandPalette isOpen={isPaletteOpen} setIsOpen={setIsPaletteOpen} />
      <Header onOpenPalette={() => setIsPaletteOpen(true)} />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/curriculum' element={<Curriculum />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/projects/:projectId' element={<ProjectDetail />} />
        <Route path='/publications' element={<Publications />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}
